import { graphql } from 'client/gql';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useContext, useState } from 'react';
import { useQuery } from 'urql';
import { showUserDbErrorToast } from 'utils/toasts';
import { BpSubpage } from '../../../components/BpSubpage/BpSubpage';
import { OrganizationConfigContext } from '../../../context/OrganizationConfigContext';
import { useAuthClaims } from '../../../hooks/useAuthClaims';
import { ThreemaAssignModal, ThreemaAssignModalProps } from './threema/ThreemaAssignModal';
import { ThreemaTable } from './threema/ThreemaTable';

export const ThreemaSubpageQueryDocument = graphql(`
  query ThreemaSubpageData($organizationUuid: ID!) {
    ...ThreemaTable
    ...ThreemaAssignModal
  }
`);

export const SettingsThreemaSubpage = () => {
  const { pimAuthClaims } = useAuthClaims();
  const organization = pimAuthClaims.getOrganization();
  const organizationUuid = pimAuthClaims.getOrganizationUuid();
  const { threemaLicense } = useContext(OrganizationConfigContext);
  const [openedThreemaProps, setOpenedThreemaProps] =
    useState<Pick<ThreemaAssignModalProps, 'threemaDetails'>['threemaDetails']>(null);

  const [{ data, error }, refetch] = useQuery({
    query: ThreemaSubpageQueryDocument,
    variables: {
      organizationUuid,
    },
  });

  if (error) showUserDbErrorToast();

  const permissions = usePermissionChecker();

  return (
    <BpSubpage isForbidden={!threemaLicense || !permissions?.isOrganizationAdmin(organization)}>
      <ThreemaTable
        query={data}
        refetch={refetch}
        handleAssignClick={(threemaProps) => setOpenedThreemaProps(threemaProps)}
      />
      <ThreemaAssignModal
        query={data}
        isOpen={Boolean(openedThreemaProps)}
        threemaDetails={openedThreemaProps}
        onRequestClose={() => {
          refetch();
          setOpenedThreemaProps(null);
        }}
      />
    </BpSubpage>
  );
};
